import React, { useEffect, useState } from "react";
import OfferLabels from "@/components/OfferLabels";
import useCountDown from "@core/helpers/client/hooks/useCountDown";

const OfferBox = ({
    selected_mix_variant,
    check_product_availability,
    check_product_offer,
}) => {
    const is_available = check_product_availability(selected_mix_variant);
    const has_offer = check_product_offer(selected_mix_variant);
    const offerLabel = selected_mix_variant?.custom_fields?.custom_offer_label;

    const expire_at = parseInt(selected_mix_variant?.price?.offer_expireAt);
    const start_at = parseInt(selected_mix_variant?.price?.offer_startAt);

    // زمان فقط بعد از mount خوانده می‌شود: Date.now() در رندر سرور و hydration فرق می‌کند و متن شمارنده
    // hydration mismatch می‌ساخت. تا آن موقع شمارنده و نوار «فروش رفته» نمایش داده نمی‌شوند.
    const [now, setNow] = useState(null);

    useEffect(() => {
        const shouldTick =
            selected_mix_variant?.price?.show_discount_timer &&
            has_offer &&
            expire_at > 0 &&
            start_at > 0 &&
            is_available;

        if (!shouldTick) return;

        setNow(Date.now());

        const interval = setInterval(() => {
            setNow(Date.now());
        }, 1000);

        return () => clearInterval(interval);
    }, [selected_mix_variant, has_offer, is_available]);

    const is_offer_active =
        selected_mix_variant?.price?.show_discount_timer &&
        has_offer &&
        expire_at > 0 &&
        start_at > 0 &&
        is_available &&
        now !== null &&
        expire_at > now;

    const timer = is_offer_active ? expire_at - now : undefined;

    const total_time = expire_at - start_at;
    const remain_time = timer;

    const timer_percent = total_time > 0 && remain_time > 0
        ? (1 - remain_time / total_time) * 100
        : 0;

    const { counter_down, convert_countdown_time } = useCountDown({
        number: timer ? Math.floor(timer / 1000) : 0,
        countdown_className:
            "dir-ltr whitespace-nowrap h-[18px] lg:h-[22px] text-sm font-bold text-jmt-red-700",
    });

    if (!is_available) return null;

    return (
        <>
            {offerLabel || timer ? (
                <div className="flex items-center justify-between">
                    <OfferLabels offerLabel={offerLabel} size="lg" />

                    <div className="flex items-center">
                        {timer > 0 &&
                            convert_countdown_time(counter_down, {
                                formats: ["hours", "minutes", "seconds"],
                                convertDaysToHours: true,
                            })}
                    </div>
                </div>
            ) : ""}

            {is_offer_active ? (
                <div>
                    <div className="flex items-center justify-between gap-1">
                        <span className="text-xs whitespace-nowrap text-jmt-red-700">
                            {timer_percent?.toFixed()}٪ فروش رفته
                        </span>
                        <div dir="ltr" className="h-1 bg-jmt-neutral-200 rounded-lg overflow-hidden w-full">
                            <div
                                className="h-1 bg-jmt-red-700 rounded-lg transition-all duration-300"
                                style={{ width: `${timer_percent?.toFixed()}%` }}
                            />
                        </div>
                    </div>
                </div>
            ) : ""}
        </>
    );
};

export default OfferBox;